export enum CenterConfigEnum {
  Queue = 'Queue.IsQueueEnabled',
}
